"use client";

import { useState } from "react";
import Link from "next/link";
import { trackProductEvent } from "@/lib/analytics";

const NAV_LINKS = [
  { href: "/coacher", label: "Coacher" },
  { href: "/ressurser", label: "Ressurser" },
  { href: "/butikk", label: "Butikk" },
  { href: "/bli-coach", label: "For coacher" },
  { href: "/om-oss", label: "Om oss" },
];

export default function SiteHeader({ activePath }: { activePath?: string }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="sticky top-0 z-30 bg-stone-50/85 backdrop-blur-md border-b border-stone-200/60">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between gap-6">
          <Link href="/" className="flex items-center gap-2 shrink-0">
            <svg viewBox="0 0 32 32" fill="none" className="w-7 h-7" aria-hidden>
              <circle cx="16" cy="16" r="11" stroke="#44403c" strokeWidth="1" />
              <circle cx="16" cy="16" r="7.5" stroke="#57534e" strokeWidth="0.7" />
              <polygon points="16,6 17.5,13 16,12 14.5,13" fill="#1c1917" />
              <polygon points="16,26 14.5,19 16,20 17.5,19" fill="#78716c" />
              <path d="M16,5 A11,11 0 1,0 16,27" stroke="#44403c" strokeWidth="1.8" strokeLinecap="round" fill="none" />
            </svg>
            <span className="font-medium tracking-tight">Coachguiden</span>
          </Link>

          <nav className="hidden md:flex items-center gap-7 text-sm text-stone-600 flex-1 justify-center">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.href}
                href={l.href}
                onClick={
                  l.href === "/butikk"
                    ? () => trackProductEvent("select_content", { content_name: "butikk-indeks", method: "header-nav" })
                    : undefined
                }
                className={
                  activePath === l.href ? "text-stone-900 font-medium" : "hover:text-stone-900 transition-colors"
                }
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2 shrink-0">
            <Link
              href="/coach"
              className="hidden md:inline-block text-sm text-stone-600 hover:text-stone-900 px-4 py-2 transition-colors"
            >
              Logg inn
            </Link>
            <Link
              href="/"
              className="hidden md:inline-block bg-stone-900 hover:bg-stone-800 text-white text-sm font-medium px-5 py-2.5 rounded-full transition-all"
            >
              Finn coach
            </Link>

            <button
              onClick={() => setOpen(!open)}
              aria-label="Meny"
              className="md:hidden p-2 -mr-2 text-stone-700"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-6 h-6">
                {open ? (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </header>

      {open && (
        <div className="md:hidden fixed inset-0 top-16 bg-stone-50 z-20 px-6 py-6 overflow-y-auto">
          <nav className="space-y-1">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.href}
                href={l.href}
                onClick={() => {
                  if (l.href === "/butikk") {
                    trackProductEvent("select_content", { content_name: "butikk-indeks", method: "header-nav-mobil" });
                  }
                  setOpen(false);
                }}
                className={`block px-4 py-3 rounded-xl text-base ${
                  activePath === l.href ? "bg-stone-100 text-stone-900 font-medium" : "text-stone-700"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <div className="border-t border-stone-200 mt-4 pt-4 space-y-1">
              <Link
                href="/coach"
                onClick={() => setOpen(false)}
                className="block px-4 py-3 rounded-xl text-base text-stone-700"
              >
                Logg inn
              </Link>
              <Link
                href="/"
                onClick={() => setOpen(false)}
                className="block px-4 py-3 rounded-xl text-base bg-stone-900 text-white font-medium text-center"
              >
                Finn coach
              </Link>
            </div>
          </nav>
        </div>
      )}
    </>
  );
}
